// src/components/Background/Background.js

import React from 'react';
import { Box } from '@mui/material';
import BGLight from '../../assets/BGLight.png';

const Background = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        // Use 100dvh for iOS Safari to account for the address bar, fallback to 100vh
        height: { xs: '100vh', '@supports (height: 100dvh)': { height: '100dvh' } },
        backgroundImage: `url(${BGLight})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        // Note: flex, justifyContent, and alignItems have been removed.
        // Safari incorrectly applies flex centering to absolutely positioned children,
        // which was causing the unwanted top gap.
      }}>
      {/* === SEMI-TRANSPARENT SHEET OVERLAY === */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.5)', // 50% white transparent sheet
          zIndex: 0, // Keeps it above the background image but below the content
        }}
      />

      {/* === PAGE CONTENT === */}
      {children}
    </Box>
  );
};

export default Background;
